<template>
  <div class="card">
    <div class="card-content">
      <div class="info">
        <span class="title">{{ productName }}</span>
        <span class="status">{{ taskStatusName }}</span>
      </div>
      <div class="right-name" v-if="rightName">{{ rightName }}</div>
    </div>
    <div class="card-footer">
      <step :steps="steps" class="footer-step"></step>
    </div>
  </div>
</template>

<script>
import Step from "@/components/steps/index.vue";
import {
  Services,
  ServiceSteps,
  OrderStatusTxt,
  TaskStatusTxt,
  TaskStatus
} from "@/common/constant.js";
	import OrderHandler from "@/common/orderHandler.js"

export default {
  components: {
    Step,
  },
  props: [
    "type",
    "productName",
    "remark",
    "orderStatus",
    "taskStatus",
    "rightName",
    "productType",
    "detail"
  ],
  data() {
    return {
      // 	productName: "道路救援-搭电",
      // 	rightName: "道路救援权益名称"
      // steps: ['下单', '自驾前往', '现场服务', '出示二维码'],
      steps: [],
      stepsList: '',
      active: 0,
    };
  },
  watch: {
    type(val) {
      this.updateData();
    },
    orderStatus(val) {
      this.updateData();
    },
    taskStatus(val) {
      this.updateData();
    },
    productType(val) {
      this.updateData();
    },
  },
  computed: {
    taskStatusName() {
      return this.taskStatus ? TaskStatus[this.taskStatus] : "";
    },
  },
  methods: {
    updateData() {
        if (this.type === Services.DrivingParent) {
					this.steps = ServiceSteps.Driving
				} else if (this.type === Services.InspectParent) {
					//上线年检（接送车）
					if (this.productType === Services.TakeCarInspect){
						this.steps = ServiceSteps.TakeCarInspect
					}else if(this.productType === Services.DriveInspect){
						this.steps = ServiceSteps.DriveInspect
					} else{
						this.steps = ServiceSteps.FreeInspect
					}
				} else if (this.productType === Services.PaintRepair) {
					this.steps = ServiceSteps.PaintRepair
					//安全检测
        } else if (this.productType === Services.SafetyInspect) {
          this.steps = ServiceSteps.SafetyInspect;
				} else {
					this.steps = ServiceSteps.Rescue
				}
    },
  },
};
</script>

<style lang="scss" scoped>
//样式会有问题，待调试
// .ZIJIN {
// 		.card {
//       .footer{
//         background: url(~@/assets/img/service_step.png) no-repeat;
//       }
// 		}
// }

.card {
  background: #ffffff;
  padding-bottom: 10px;
  box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);

  &-content {
    display: flex;
    padding: 12px 15px 0px;
    flex-direction: column;

    .info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .status {
        color: #ff8148;
        font-size: 13px;
        text-align: right;
      }

      .title {
        color: #333333;
        font-size: 16px;
        font-weight: 500;
        font-family: PingFangSC-Medium;
      }
    }

    .right-name {
      color: #666666;
      font-size: 13px;
      margin-top: 10px;
    }
  }

  &-footer {
    margin-top: 2px;
    margin-left: 15px;
    margin-right: 15px;
    padding: 15px 0px;
    background: url(~@/assets/img/service_step.png) no-repeat;
    background-size: 7rem 0.8rem;
    background-position: center center;
    .footer-step {
      font-size: 10px;
      color: #9a8fcc;
    }
  }
}
</style>
